import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import BottomPopupDropdownOptions from '@components/BottomPopupDropdownOptions';
import CommonImage from '@components/CommonImage';
import AddDesignToCollection from '@components/design-uploads/AddDesignToCollection';
import DesignItem from '@components/DesignItem';
import LoaderComponent from '@components/LoaderComponent';
import { toastSuccess } from '@components/Toast';

import useWindowSize from '@hooks/useWindowSize';

import InventoryAndStickerModal from '@features/favourites/components/InventoryAndStickerModal';
import SampleLocationDetailsModal from '@features/favourites/components/SampleLocationDetailsModal';
import SelectFolderPopup from '@features/favourites/components/SelectFolderPopup';
import UpdateSampleLocation from '@features/favourites/components/UpdateSampleLocation';
import FilterTopHeader from '@features/filter/FilterTopHeader';
import {
	allFilterPages,
	designFieldList,
	generateProductListParams
} from '@features/filter/static/filterUtil';
import FilterComponent from '@features/filter/v2/FilterComponent';
import PublishDesign from '@features/collection/components/PublishDesign';

import { clearDesignViewModalInfo, setDesignViewModalInfo } from '@store/actions/DesignViewModalAction';
import { handleFilter } from '@store/actions/FilterAction';
import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { likeProduct } from '@store/design/action';
import { removeSearchResult } from '@store/searchOptions/actions';

import { fetchDependentFilterList } from '@services/commonService';
import { getPickAndChoosePrice } from '@services/productService';

import { isPageReachBottom, showDesignViewPage } from '@utils/Util';

import { LIST_VIEW_TYPE } from '@/constants/constant';

import { storeProductData } from '@/store/actions/DesignAction';
import AddTaskModal from '@/features/Scan/components/AddTaskModal';
import CreateNewTask from '@/features/Scan/components/CreateNewTask';
import { useDownloadTpSummaryMutation } from '@/api/commonDownloadsApi';

const DesignListV2 = ({
	viewType,
	onClickTab,
	onSetDefaultView,
	pathName,
	selectedTab,
	selectedProductId,
	setIsSetParam,
	isSetParamExist = false
}) => {
	const [loader, setLoader] = useState(true);
	const [showAddCollectionPopup, setShowAddCollectionPopup] = useState(false);
	const filterData = useSelector((store) => store.filterFieldStore);
	const [designIdList, setDesignIdList] = useState([]);
	const [showFilter, setShowFilter] = useState(false);
	const [isOpenDesign, setIsOpenDesign] = useState(false);
	const [selectedProducts, setSelectedProducts] = useState([]);
	const [idsForOfferPrice, setIdsForOfferPrice] = useState([]);
	const [allOfferPrices, setAllOfferPrices] = useState([]);
	const [activeTab, setActiveTab] = useState('');
	const [page] = useState(0);
	const dispatch = useDispatch();
	const myStateRef = useRef({});
	const isDataLoading = useRef(false);
	const [designIdToView, setDesignIdToView] = useState(null);
	const [designList, setDesignList] = useState(null);
	const [isDefaultOpenBasicInfo, setIsDefaultOpenBasicInfo] = useState(false);
	const filterResponse = useSelector((store) => store.filterResponseStore);
	const isShowPriceTypeStore = useSelector((store) => store.systemPreferenceReducer);
	const [isShowPrice, setIsShowPrice] = useState(isShowPriceTypeStore);
	const mentionedData = useSelector((store) => store.chatReducer.mentionedData);
	let filterfields = useSelector((store) => store.filterFieldStore);
	const sortValue = filterfields['sort'] && filterfields['sort'][0]?.key;
	const { ...paramsData } = generateProductListParams(filterfields);
	useWindowSize(() => setShowFilter(false));
	const [isInventoryModalOpen, setIsInventoryModalOpen] = useState(false);
	const [isShowLocationModal, setIsShowLocationModal] = useState(false);
	const [selectedLocationsToDownload, setSelectedLocationsToDownload] = useState([]);
	const [isShowUpdateLocationModal, setIsShowUpdateLocationModal] = useState(false);
	const [isShowDesignersTechpack, setIsShowDesignersTechpack] = useState(false);
	const { searchResult, isViwTechpack, isAddToFavourite } = useSelector(
		(store) => store.collectionSearchOptionStore
	);
	const [isShowFavouriteFolderPopup, setIsShowFavouriteFolderPopup] = useState(false);
	const [isShowCreateNew, setIsShowCreateNew] = useState(false);
	const [currentLikedStyle, setCurrentLikedStyle] = useState(null);
	const updatedArchivedProductId = useSelector(
		(store) => store.collectionSearchOptionStore.updatedArchivedProductId
	);
	const [isShowPublishModal, setIsShowPublishModal] = useState(false);
	const [isShowUpdateTaskModal, setIsShowUpdateTaskModal] = useState(false);
	const [taskInputValueFromTaskModal, setTaskInputValueFromTaskModal] = useState('');
	const [isShowAddNewTaskModal, setIsShowAddNewTaskModal] = useState(false);
	const location = useLocation();
	const [downloadTpSummary] = useDownloadTpSummaryMutation();

	const onUpdateHasMentioned = (productId) => {
		let productList = designList?.data?.map((item) => {
			if (item.id === productId) {
				return {
					...item,
					hasUnseenMention: true
				};
			}
			return item;
		});
		setDesignList({ data: productList });
	};

	useEffect(() => {
		if (mentionedData?.productId) {
			onUpdateHasMentioned(mentionedData?.productId);
		}
	}, [mentionedData]);

	useEffect(() => {
		if (selectedProductId) {
			setDesignIdToView(selectedProductId);
		}
	}, [selectedProductId]);

	useEffect(() => {
		if (searchResult) {
			setDesignIdToView(searchResult);
		}
	}, [searchResult]);

	useEffect(() => {
		setIsShowPrice(isShowPriceTypeStore);
	}, [isShowPriceTypeStore]);

	const setIsDataLoading = (data) => {
		isDataLoading.current = data;
	};

	const setMyState = (data) => {
		myStateRef.current = data;
	};

	const generateSortParams = () =>
		pathName === '/nitex-studio' ? '&sort=dateAdded,desc' : '&sort=id,desc';

	useEffect(() => {
		setDesignList(filterResponse);
	}, [filterResponse]);

	useEffect(() => {
		setMyState(designList);
		let designIds = designList?.data
			?.filter((product) => product.extraFlag && showDesignViewPage(product))
			.map((product) => product.id);
		setDesignIdList(designIds);
	}, [designList]);

	const removeAvailabilityStatusAll = (data) => {
		if (Array.isArray(data.availabilityStatusList)) {
			const index = data.availabilityStatusList.indexOf('ALL');
			if (index > -1) {
				data.availabilityStatusList.splice(index, 1);
			}

			if (data.availabilityStatusList.length === 0) {
				if (pathName === '/nitex-studio') {
					data.isNitexStudioPublishedTab = true;
					delete data.availabilityStatusList;
				} else {
					delete data.availabilityStatusList;
				}
			}
		}

		if (Object.prototype.hasOwnProperty.call(data, 'sort')) {
			delete data['sort'];
		}

		return data;
	};

	useEffect(() => {
		if (filterData?.availabilityStatusList) {
			window.scrollTo(0, 0);
			dispatch(openLoader());
			let requestBody = generateProductListParams(filterfields);
			requestBody = removeAvailabilityStatusAll(requestBody);
			if (activeTab === 'Sold' && isShowDesignersTechpack) {
				requestBody.isSoldDesignerStyle = true;
				delete requestBody.availabilityStatusList;
			}
			let queryString = `?page=${page}&size=48`;
			mergeSoldDesignParams(requestBody);
			queryString += filterfields.sort === undefined ? generateSortParams() : `&sort=${sortValue}`;
			dispatch(
				handleFilter(
					'getManageProducts',
					queryString,
					false,
					'POST',
					requestBody,
					isViwTechpack,
					false
				)
			).finally(() => {
				dispatch(closeLoader());
			});

			document.addEventListener('scroll', handleScroll);
			return () => {
				document.removeEventListener('scroll', handleScroll);
			};
		}
	}, [filterData, updatedArchivedProductId, isShowDesignersTechpack]);

	useEffect(() => {
		if (showFilter) {
			const cleanParamsData = removeAvailabilityStatusAll({ ...paramsData });
			if (activeTab === 'Sold' && isShowDesignersTechpack) {
				cleanParamsData.isSoldDesignerStyle = true;
				delete cleanParamsData.availabilityStatusList;
			}
			mergeSoldDesignParams(cleanParamsData);
			dispatch(
				fetchDependentFilterList({ type: 'PRODUCT_LIST' }, cleanParamsData, 'POST', cleanParamsData)
			);
		}
	}, [showFilter, filterData, isShowDesignersTechpack]);

	useEffect(() => {
		let activeTab = filterData?.availabilityStatusList || [];
		let currentTabOfGlobal = activeTab.find((item) => item.type === 'SELECT');
		setActiveTab(currentTabOfGlobal?.key);
	}, [filterData]);

	const onLastDesignReached = () => {
		if (!myStateRef.current) return;
		let { totalElements, currentPage, data } = myStateRef.current;
		let pageNumber = currentPage === 0 ? 4 : parseInt(currentPage + 1);
		if (totalElements > 0) {
			if (totalElements !== data.length && !isDataLoading.current) {
				setLoader(true);
				setIsDataLoading(true);
				let requestBody = generateProductListParams(filterfields);
				requestBody = removeAvailabilityStatusAll(requestBody);
				if (activeTab === 'Sold' && isShowDesignersTechpack) {
					requestBody.isSoldDesignerStyle = true;
					delete requestBody.availabilityStatusList;
				}
				let queryString = `?page=${pageNumber}&size=12`;
				mergeSoldDesignParams(requestBody);
				queryString += filterfields.sort === undefined ? generateSortParams() : `&sort=${sortValue}`;
				dispatch(
					handleFilter(
						'getManageProducts',
						queryString,
						true,
						'POST',
						requestBody,
						isViwTechpack,
						isAddToFavourite
					)
				).finally(() => {
					dispatch(closeLoader());
					setIsDataLoading(false);
				});
			}
		}
	};

	const handleScroll = () => {
		if (isPageReachBottom()) {
			onLastDesignReached();
		}
	};

	const mergeSoldDesignParams = (requestBody) => {
		const params = new URLSearchParams(location.search);
		if (params.get('designType') === 'SOLD') {
			requestBody.isSoldDesignerStyle = true;
			requestBody.hasPresentationImage = true;
			delete requestBody.availabilityStatusList;
			delete requestBody.isNitexStudioPublishedTab;
		}
	};

	const onUpdateProductStatus = () => {
		let { currentPage } = myStateRef.current;
		let requestBody = generateProductListParams(filterfields);
		requestBody = removeAvailabilityStatusAll(requestBody);
		let queryString = `?page=${currentPage}&size=12`;
		mergeSoldDesignParams(requestBody);
		queryString += filterfields.sort === undefined ? generateSortParams() : `&sort=${sortValue}`;
		dispatch(
			handleFilter(
				'getManageProducts',
				queryString,
				false,
				'POST',
				requestBody,
				isViwTechpack,
				isAddToFavourite
			)
		).finally(() => {
			dispatch(closeLoader());
		});
	};

	const onClickDesignImage = (designId, openBasicInfo = false) => {
		setIsDefaultOpenBasicInfo(openBasicInfo);
		setDesignIdToView(designId?.id);
	};

	const onCloseViewModal = () => {
		if (setIsSetParam) setIsSetParam(false);
		setDesignIdToView(null);
		setIsDefaultOpenBasicInfo(false);
		isOpenDesign && setIsOpenDesign(false);
		dispatch(clearDesignViewModalInfo({}));
		dispatch(removeSearchResult(null));
	};

	useEffect(() => {
		if (designIdToView !== null) {
			openDesignViewModal();
		}
	}, [designIdToView]);

	const openDesignViewModal = () => {
		dispatch(
			setDesignViewModalInfo({
				id: designIdToView,
				isShowMergeTechPack: isSetParamExist,
				onCloseViewModal: onCloseViewModal,
				updateProductStatus: onUpdateProductStatus,
				source: 'PRODUCT_LIST',
				designIdList: designIdList,
				loadMoreDesign: true,
				onLastDesignReached: onLastDesignReached,
				isDefaultOpenBasicInfo: isDefaultOpenBasicInfo
			})
		);
	};

	const onSetLike = (id) => {
		const productList = designList?.data.map((item) => {
			if (item.id === id) {
				return {
					...item,
					liked: true
				};
			}
			return item;
		});
		setDesignList({ ...designList, data: productList });
	};

	// const onSetUnlike = (id) => {
	// 	const productList = designList?.data.map((item) => {
	// 		if (item.id === id) {
	// 			return {
	// 				...item,
	// 				liked: false
	// 			};
	// 		}
	// 		return item;
	// 	});
	// 	setDesignList({ ...designList, data: productList });
	// };

	const handleSuccessLikeProduct = () => {
		!isShowFavouriteFolderPopup && setIsShowFavouriteFolderPopup(true);
		toastSuccess('Added to favourite');
	};

	const onLikeProduct = async (id) => {
		onSetLike(id);
		setIsShowFavouriteFolderPopup(true);
		await dispatch(likeProduct(id, handleSuccessLikeProduct));
		setCurrentLikedStyle(id);
	};

	const isMyDesignTab = () => {
		return filterData?.filterCategory?.some((item) => {
			if (item?.type === 'SELECT' && item?.value === 'MY_DESIGN') return true;
			return false;
		});
	};

	const downloadReportByProductIds = () => {
		downloadTpSummary({
			productIds: selectedProducts,
			inventoryCountryIds: selectedLocationsToDownload
		})
			.unwrap()
			.then(() => {
				setIsShowLocationModal(false);
				setSelectedLocationsToDownload([]);
			});
	};

	const handleDownload = (type) => {
		if (type === 'DOWNLOAD_REPORT') {
			downloadReportByProductIds();
		} else if (type === 'SAMPLE_LOCATION_DETAILS') {
			setIsShowLocationModal(true);
		}
	};

	const getOfferPriceForProduct = async () => {
		setLoader(true);
		try {
			const response = await getPickAndChoosePrice(idsForOfferPrice);
			setAllOfferPrices((prevPrices) => ({
				...prevPrices,
				...response
			}));
			setLoader(false);
		} catch {
			setLoader(false);
		}
	};

	useEffect(() => {
		if (designList?.data?.length > 0) {
			const currentIds = designList.data.map((design) => design.id);
			if (myStateRef.current?.currentPage === 0) {
				setIdsForOfferPrice(currentIds.slice(0, 48));
			} else {
				setIdsForOfferPrice(currentIds.slice(-12));
			}
		}
	}, [designList]);

	useEffect(() => {
		if (idsForOfferPrice?.length > 0) {
			getOfferPriceForProduct();
		}
	}, [idsForOfferPrice]);

	const handleUpdateDesignOnPublish = (productIds) => {
		const updatedProductList = designList.data.map((product) => {
			if (productIds.includes(product.id)) {
				return {
					...product,
					productStatusList: product.productStatusList.map((status) => ({
						...status,
						entity: 'DESIGN',
						status: 'Published'
					}))
				};
			}
			return product;
		});
		setDesignList({ ...designList, data: updatedProductList });
	};

	const renderDesignList = () => {
		let isSelected = isMyDesignTab();
		if (designList?.data?.length > 0) {
			return designList.data.map((design, index) => {
				const offerPriceInfo = allOfferPrices[design.id];
				return (
					<DesignItem
						design={design}
						index={index}
						selectedProducts={selectedProducts}
						setSelectedProducts={setSelectedProducts}
						onClickDesignImage={onClickDesignImage}
						key={`design_${index}`}
						onLikeProduct={onLikeProduct}
						fromPage={'DESIGN_PAGE'}
						isMyDesignTabSelected={isSelected}
						isShowPrice={isShowPrice}
						isFromNitexStudio={pathName === '/nitex-studio'}
						offerPriceInfo={offerPriceInfo || []}
					/>
				);
			});
		}
	};

	const clearSelection = () => {
		setSelectedProducts([]);
	};

	const renderAlertMessage = () => {
		if (designList?.data?.length === 0) {
			return (
				<div className="alert alert-secondary text-center">
					<p>No design found</p>
				</div>
			);
		}
	};

	const renderCollectionModal = () => {
		if (selectedProducts.length > 0) {
			return (
				<div className="design-count-section design-list-count bg-white shadow-8dp">
					<div className="count-info d-flex justify-content-between align-items-center">
						<div className="design-count">
							<p className="semibold-18">{selectedProducts.length}</p>
						</div>

						<div className="buttons ">
							<button
								className="button text size36"
								onClick={() => setShowAddCollectionPopup(true)}
							>
								<CommonImage src="/icons/add-round.svg" alt="add" />
								<span className="ml-1">Collection</span>
							</button>
						</div>
						<div className="buttons ">
							<button
								className="button text size36"
								onClick={() => setIsInventoryModalOpen(true)}
							>
								Inventory & Sticker
							</button>
						</div>
						<div className="buttons ">
							<button className="button text size36">
								<span className="ml-1" onClick={() => setIsShowUpdateLocationModal(true)}>
									Sample Location
								</span>
							</button>
						</div>
						<div className="buttons" onClick={() => setIsShowPublishModal(true)}>
							<button className="button text size36">
								<span className="ml-1">Publish</span>
							</button>
						</div>
						<div className="buttons" onClick={() => setIsShowUpdateTaskModal(true)}>
							<button className="button text size36">
								<span className="ml-1">Update task</span>
							</button>
						</div>
						<div>
							<BottomPopupDropdownOptions
								onActionClick={handleDownload}
								options={[
									{
										id: 'DOWNLOAD_REPORT',
										title: 'Techpack Summary',
										value: 'DOWNLOAD_REPORT'
									},
									{
										id: 'SAMPLE_LOCATION_DETAILS',
										title: 'Sample Location Details',
										value: 'SAMPLE_LOCATION_DETAILS'
									}
								]}
							/>
						</div>

						<div className="text-right close-icon" onClick={clearSelection}>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="25"
								height="24"
								viewBox="0 0 25 24"
								fill="none"
							>
								<path
									d="M18.5038 5.7107C18.1138 5.3207 17.4838 5.3207 17.0938 5.7107L12.2038 10.5907L7.31383 5.7007C6.92383 5.3107 6.29383 5.3107 5.90383 5.7007C5.51383 6.0907 5.51383 6.7207 5.90383 7.1107L10.7938 12.0007L5.90383 16.8907C5.51383 17.2807 5.51383 17.9107 5.90383 18.3007C6.29383 18.6907 6.92383 18.6907 7.31383 18.3007L12.2038 13.4107L17.0938 18.3007C17.4838 18.6907 18.1138 18.6907 18.5038 18.3007C18.8938 17.9107 18.8938 17.2807 18.5038 16.8907L13.6138 12.0007L18.5038 7.1107C18.8838 6.7307 18.8838 6.0907 18.5038 5.7107Z"
									fill="#6A7181"
								/>
							</svg>
						</div>
					</div>
				</div>
			);
		}
	};

	return (
		<LoaderComponent loading={loader}>
			<div className={`${isShowFavouriteFolderPopup ? 'show' : 'hide'}`}>
				<SelectFolderPopup
					onClose={() => setIsShowFavouriteFolderPopup(false)}
					isShowCreateNew={isShowCreateNew}
					setIsShowCreateNew={setIsShowCreateNew}
					currentLikedStyle={currentLikedStyle}
				/>
			</div>
			<FilterTopHeader
				setShowFilter={setShowFilter}
				showFilter={showFilter}
				addNewTitle={'Design'}
				searchBoxPlaceHolder={'Design name & number'}
				onClickTab={onClickTab}
				onSetDefaultView={onSetDefaultView}
				isFromNitexStudio={pathName === '/nitex-studio'}
				viewType={selectedTab}
				pathName={pathName}
				setIsShowFavouriteFolderPopup={setIsShowFavouriteFolderPopup}
				isShowDesignersTechpack={isShowDesignersTechpack}
				setIsShowDesignersTechpack={setIsShowDesignersTechpack}
			/>
			<section
				className={`filter-data-container filter-v3-data-container bg-white py-0 ${
					pathName === '/nitex-studio' ? 'nitex-studio-design' : 'under-inner-tabs'
				}`}
			>
				<FilterComponent
					filterPageName={allFilterPages.PRODUCT_LIST}
					fields={
						pathName === '/nitex-studio'
							? { ...designFieldList, mineAndShared: false }
							: designFieldList
					}
					showFilter={showFilter}
					isDependentFilter={true}
				/>
				<div className="data-table">
					<div className="design-list-container">
						<div
							className={`design-list-row ${
								viewType === LIST_VIEW_TYPE.NARROW_VIEW
									? 'narrow-view'
									: viewType === LIST_VIEW_TYPE.IMAGE_VIEW
										? 'image-view'
										: ''
							}`}
						>
							{renderDesignList()}
						</div>
						{renderAlertMessage()}
					</div>
					{renderCollectionModal()}
				</div>
			</section>
			{isInventoryModalOpen && (
				<InventoryAndStickerModal
					onClose={() => setIsInventoryModalOpen(false)}
					productIds={selectedProducts}
					isDesignEdit={true}
					designList={designList?.data?.map((design) => ({ productResponse: { ...design } }))}
					setIsShowInventoryModal={setIsInventoryModalOpen}
				/>
			)}
			{isShowLocationModal && (
				<SampleLocationDetailsModal
					onClose={() => {
						setIsShowLocationModal(false);
						setSelectedLocationsToDownload([]);
					}}
					downloadReportByProductIds={downloadReportByProductIds}
					selectedLocationsToDownload={selectedLocationsToDownload}
					setSelectedLocationsToDownload={setSelectedLocationsToDownload}
				/>
			)}
			{showAddCollectionPopup && (
				<AddDesignToCollection
					type="ADD_NEW"
					actionType="COPY"
					title="Copy to collection"
					onAddDesign={() => {
						setShowAddCollectionPopup(false);
					}}
					onCancel={async () => {
						setShowAddCollectionPopup(false);
					}}
					designIdList={selectedProducts}
				/>
			)}
			{isShowUpdateLocationModal && (
				<UpdateSampleLocation
					selectedProductIds={selectedProducts}
					setIsShowUpdateLocationModal={setIsShowUpdateLocationModal}
					isOnTheWay
				/>
			)}
			{isShowPublishModal && (
				<PublishDesign
					selectedProducts={selectedProducts}
					onClose={() => {
						dispatch(storeProductData('selectedProductIds', []));
						setIsShowPublishModal(false);
					}}
					onSubmitSuccess={handleUpdateDesignOnPublish}
				/>
			)}
			{isShowUpdateTaskModal && (
				<AddTaskModal
					onClose={(taskName) => {
						if (taskName) {
							setTaskInputValueFromTaskModal(taskName);
						}
						setIsShowUpdateTaskModal(false);
					}}
					onOpenAddNewTaskModal={() => setIsShowAddNewTaskModal(true)}
					productIdList={selectedProducts}
				/>
			)}
			{isShowAddNewTaskModal && (
				<CreateNewTask
					onClose={() => {
						setIsShowAddNewTaskModal(false);
					}}
					onOpenTaskModal={() => setIsShowUpdateTaskModal(true)}
					taskInputValueFromTaskModal={taskInputValueFromTaskModal}
				/>
			)}
		</LoaderComponent>
	);
};

export default DesignListV2;
